<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div
              class="w-4/5 text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              Nuevo levantamiento
            </div>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-lg"
              id="levantamientoForm"
              @submit.prevent
            >
              <div v-show="showCategoriesView">
                <div class="flex flex-wrap -mx-3 pb-3">

                  <!-- campo para titulo -->
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="name"
                      >Título</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      name="name"
                      v-model="nameLevantamiento"
                    />
                    <p
                      v-if="errors.name"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Ingrese un título.
                    </p>
                  </div>
                  <!-- /campo para titulo -->

                  <!--selector estado-->
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="fromProject"
                      >Estado</label
                    >
                    <div class="relative">
                      <select
                        v-model="selectedEstado"
                        name="estado"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione un estado</option>
                        <template v-for="estado in estados">
                          <option
                            
                            :value="estado"
                          >
                            {{ estado.entidad_nombre }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.estado"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un estado.
                    </p>

                  </div>                  
                  <!--/selector estado-->

                  <!--selector municipio-->
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="fromProject"
                      >Municipio</label
                    >
                    <div class="relative">
                      <select
                        v-model="selectedMunicipio"
                        name="municipio"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione un municipio</option>
                        <template v-for="municipio in municipios">
                          <option
                            
                            :value="municipio"
                          >
                            {{ municipio.municipio_nombre }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.municipio"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un municipio.
                    </p>

                  </div>                  
                  <!--/selector municipio-->     

                  <!-- campo para comunidad -->
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="comunidad"
                      >Comunidad</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="comunidad"
                      type="text"
                      name="comunidad"
                      v-model="comunidad"
                    />
                  </div>
                  <!-- /campo para comunidad -->                               

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="fromProject"
                      >¿Desea colaborar con un proyecto?</label
                    >
                    <div class="relative">
                      <select
                        v-model="fromProject"
                        name="fromProject"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <option>Si</option>
                        <option>No</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.selectColab"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione una opción.
                    </p>

                  </div>

                  <div
                    class="w-full px-3 mb-6 md:mb-0"
                    v-if="fromProject === 'Si'"
                  >
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="selectProject"
                      >Proyecto</label
                    >
                    <div class="relative">
                      <select
                        v-model="projectSelected"
                        name="selectProject"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <template v-for="project in projects">
                          <option
                            :key="'projLev' + project.id"
                            :value="project.id"
                          >
                            {{ project.nombre }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.selectProject"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un proyecto.
                    </p>
                    <div v-if="projectSelected !== null" class="flex text-left">
                      <button
                        @click="showProjectDetailModal()"
                        class="bg-transparent hover:bg-purple-500 text-purple-700 font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border border-purple-500 hover:border-transparent rounded"
                      >
                        Ver proyecto
                      </button>
                    </div>
                  </div>

<!--                   <div
                    class="w-full px-3 mb-6 md:mb-0"
                    v-if="fromProject === 'No'"
                  >
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="isMaterial"
                      >¿Lo que quieres registrar es un objeto, un lugar, un
                      edificio?</label
                    >
                    <div class="relative">
                      <select
                        v-model="isMaterial"
                        name="isMaterial"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option disabled selected>Seleccione una</option>
                        <option value="1">Si</option>
                        <option value="2">No</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.isMaterial"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione una opción.
                    </p>
                  </div> -->

<!--                   <div class="w-full px-3 mb-6 md:mb-0">
                    <label class="w-full flex items-center text-gray-900">
                      <input
                        class="mr-2 leading-tight"
                        type="checkbox"
                        v-model="sensitiveLocation"
                      />
                      <span class="text-sm">Mantener ubicación oculta</span>
                    </label>
                  </div> -->
                </div>
              </div>

              <div v-show="showMultimediaView">
                <div class="flex flex-wrap -mx-3 pb-3 px-5 justify-center">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left flex items-center"
                    >
                      Subir archivo
                      <span
                        class="pl-2 cursor-pointer"
                        @click="showingMediaProject = true"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 fill-current"
                        >
                          <path
                            d="M11.95 18Q12.475 18 12.838 17.637Q13.2 17.275 13.2 16.75Q13.2 16.225 12.838 15.863Q12.475 15.5 11.95 15.5Q11.425 15.5 11.062 15.863Q10.7 16.225 10.7 16.75Q10.7 17.275 11.062 17.637Q11.425 18 11.95 18ZM11.05 14.15H12.9Q12.9 13.325 13.088 12.85Q13.275 12.375 14.15 11.55Q14.8 10.9 15.175 10.312Q15.55 9.725 15.55 8.9Q15.55 7.5 14.525 6.75Q13.5 6 12.1 6Q10.675 6 9.788 6.75Q8.9 7.5 8.55 8.55L10.2 9.2Q10.325 8.75 10.763 8.225Q11.2 7.7 12.1 7.7Q12.9 7.7 13.3 8.137Q13.7 8.575 13.7 9.1Q13.7 9.6 13.4 10.037Q13.1 10.475 12.65 10.85Q11.55 11.825 11.3 12.325Q11.05 12.825 11.05 14.15ZM12 22Q9.95 22 8.125 21.212Q6.3 20.425 4.938 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.938 4.925Q6.3 3.575 8.125 2.787Q9.95 2 12 2Q14.1 2 15.925 2.787Q17.75 3.575 19.1 4.925Q20.45 6.275 21.225 8.1Q22 9.925 22 12Q22 14.075 21.225 15.9Q20.45 17.725 19.1 19.075Q17.75 20.425 15.925 21.212Q14.1 22 12 22ZM12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12ZM12 20Q15.35 20 17.675 17.663Q20 15.325 20 12Q20 8.675 17.675 6.337Q15.35 4 12 4Q8.725 4 6.362 6.337Q4 8.675 4 12Q4 15.325 6.362 17.663Q8.725 20 12 20Z"
                          />
                        </svg>
                      </span>
                    </label>
                    <p
                      class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                    >
                      Seleccione hasta 4 fotos o un video o un audio.
                    </p>
                    <div
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 mb-3 leading-tight focus:outline-none focus:bg-white"
                    >
                      <label
                        for="levantamientoFile"
                        class="flex w-full cursor-pointer -my-2 whitespace-no-wrap"
                      >
                        <span
                          class="bg-gray-900 text-gray-100 py-2 px-4 p rounded-l"
                          >Seleccionar archivo</span
                        >
                        <span class="py-2 px-4 truncate">{{
                          inputFilePlaceholder
                        }}</span>
                        <input
                          @change="changeLevantamientoFile"
                          class="sr-only"
                          type="file"
                          name="levantamientoFile"
                          id="levantamientoFile"
                          accept="image/png, image/jpeg, video/mp4, audio/mpeg"
                          multiple
                        />
                      </label>
                    </div>
                    <p
                      v-if="errors.emptyFile"
                      class="text-red-500 text-xs italic pb-3"
                    >
                      Seleccione un archivo.
                    </p>
                  </div>

                  <div v-show="imageSelected" class="flex flex-wrap">
                    <div
                      v-for="(preview, mediaIndex) in imagesPreviews"
                      :key="mediaIndex"
                      class="flex w-1/2 h-72 flex-grow px-2 pb-4"
                      v-show="preview.type !== ''"
                    >
                      <img
                        v-if="preview.type === 'image'"
                        :src="preview.mediaUrl"
                        class="h-full w-full object-cover"
                        alt=""
                      />
                    </div>
                  </div>

                  <div v-show="videoSelected" class="flex flex-wrap">
                    <div
                      v-for="(preview, mediaIndex) in imagesPreviews"
                      :key="mediaIndex"
                      class="flex w-1/2 h-72 flex-grow px-2 pb-4"
                      v-show="preview.type !== ''"
                    >
                      <video
                        v-if="preview.type === 'video'"
                        :src="preview.mediaUrl"
                        class="h-full w-full bg-gray-300"
                        controls
                      ></video>
                    </div>
                  </div>                  

                  <div v-show="audioSelected" class="flex flex-wrap">
                    <div
                      v-for="(preview, mediaIndex) in imagesPreviews"
                      :key="mediaIndex"
                      class="flex w-1/2 h-50 flex-grow px-2 pb-4"
                      v-show="preview.type !== ''"
                    >
                        <audio 
                          v-if="preview.type === 'audio'"
                          :src="preview.mediaUrl"
                          type=”audio/mp3″ controls 
                          controlsList="nodownload" >
                        </audio>
                    </div>
                  </div>                  

                </div>
              </div>

              <div v-show="showFormView">
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div
                    class="w-full"
                    v-for="(question, index) in questions"
                    :key="'question' + question.id_pregunta"
                  >
                    <div v-if="question.tipo === 'ABIERTA'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'question' + index"
                          type="text"
                          :name="'question' + index"
                          v-model="answers[index].respuesta"
                        />
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
<!--                       <div class="w-full px-3 mb-3">
                        <label class="w-full flex items-center text-gray-900">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            v-model="answers[index].sensible"
                          />
                          <span class="text-sm">
                            Contiene información sensible
                          </span>
                        </label>
                      </div> -->
                    </div>

                    <div v-if="question.tipo === 'MULTISELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(option, optIndex) in question.opciones"
                        >
                          <div
                            class="flex items-center text-gray-700 font-bold"
                            :class="
                              optIndex === question.opciones.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'opt' + optIndex"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="
                                answers[index].respuesta.opciones[option]
                              "
                            />
                            <span class="text-sm">
                              {{ option }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>

                        <template
                          v-for="(
                            subpregunta, subIndex
                          ) in question.subpregunta"
                        >
                          <div
                            class="w-full mb-6 md:mb-0"
                            :key="'sub' + subIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'subquestion' + subIndex"
                              >{{ subpregunta.id_pregunta }}.-
                              {{ subpregunta.texto }}</label
                            >
                            <template v-if="subpregunta.tipo === 'CAMPOS'">
                              <template
                                v-for="(campo, fIndex) in subpregunta.campos"
                              >
                                <template v-if="campo.tipo === 'texto'">
                                  <div :key="'f' + fIndex">
                                    <label
                                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                      :for="'subquestionField' + fIndex"
                                      >{{ campo.texto }}</label
                                    >
                                    <input
                                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      :id="'subquestionField' + fIndex"
                                      type="text"
                                      :name="'subquestionField' + fIndex"
                                      v-model="
                                        answers[index].respuesta.subpregunta
                                          .respuesta[campo.texto]
                                      "
                                    />
                                  </div>
                                </template>
                              </template>
<!--                               <div class="w-full px-3 mb-3">
                                <label
                                  class="w-full flex items-center text-gray-900"
                                >
                                  <input
                                    class="mr-2 leading-tight"
                                    type="checkbox"
                                    v-model="
                                      answers[index].respuesta.subpregunta
                                        .sensible
                                    "
                                  />
                                  <span class="text-sm">
                                    Contiene información sensible
                                  </span>
                                </label>
                              </div> -->
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div v-if="question.tipo === 'MULTISELECCION_CATEGORIAS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(categoria, catIndex) in question.categorias"
                        >
                          <div
                            class="flex flex-col items-center text-gray-700 font-bold"
                            :class="
                              catIndex === question.categorias.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'catQ' + catIndex"
                          >
                            <label
                              class="w-full block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ categoria.categoria_nombre }}</label
                            >
                            <template
                              v-for="(option, catOIndex) in categoria.opciones"
                            >
                              <div
                                class="flex items-center w-full"
                                :class="
                                  catOIndex === categoria.opciones.length - 1
                                    ? 'mb-2'
                                    : ''
                                "
                                :key="'catO' + catOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.categorias[
                                      categoria.categoria_nombre
                                    ][option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                      </div>
                    </div>

                    <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, scOIndex) in question.opciones"
                            >
                              <option :key="'scO' + scOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <template
                        v-for="(
                          value, key, keyIndex
                        ) in question.pregunta_condicion"
                      >
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'ABIERTA'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'questionCond' + index"
                              type="text"
                              :name="'questionCond' + index"
                              v-model="
                                answers[index].respuesta.conditional_answer[key]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.conditional_answer[key]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>

                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'MULTISELECCION'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(option, scMOIndex) in question
                                .pregunta_condicion[key].opciones"
                            >
                              <div
                                class="flex items-center text-gray-700 font-bold"
                                :class="
                                  scMOIndex ===
                                    question.pregunta_condicion[key].opciones
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'scM' + scMOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].respuesta.opciones[option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>

                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'MULTISELECCION_CATEGORIAS'
                            "
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(categoria, soMCIndex) in question
                                .pregunta_condicion[key].categorias"
                            >
                              <div
                                class="flex flex-col items-center text-gray-700 font-bold"
                                :class="
                                  soMCIndex ===
                                    question.pregunta_condicion[key].categorias
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'soMC' + soMCIndex"
                              >
                                <label
                                  class="w-full block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                  >{{ categoria.categoria_nombre }}</label
                                >
                                <template
                                  v-for="(
                                    option, soMOIndex
                                  ) in categoria.opciones"
                                >
                                  <div
                                    class="flex items-center w-full"
                                    :class="
                                      soMOIndex ===
                                      categoria.opciones.length - 1
                                        ? 'mb-2'
                                        : ''
                                    "
                                    :key="'soMO' + soMOIndex"
                                  >
                                    <input
                                      class="mr-2 leading-tight"
                                      type="checkbox"
                                      v-model="
                                        answers[index].respuesta
                                          .conditional_answer[key].respuesta
                                          .categorias[
                                          categoria.categoria_nombre
                                        ][option]
                                      "
                                    />
                                    <span class="text-sm">
                                      {{ option }}
                                    </span>
                                  </div>
                                </template>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>

                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo ===
                              'SELECCION'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta
                                "
                                :name="'questionCond' + index"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(option, condOIndex) in question
                                    .pregunta_condicion[key].opciones"
                                >
                                  <option
                                    :key="'condO' + condOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="
                              question.pregunta_condicion[key].tipo === 'CAMPOS'
                            "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <template
                              v-for="(campo, condFieldIndex) in question
                                .pregunta_condicion[key].campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'condf' + condFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'condField' + condFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'condField' + condFieldIndex"
                                    type="text"
                                    :name="'condField' + condFieldIndex"
                                    v-model="
                                      answers[index].respuesta
                                        .conditional_answer[key].respuesta[
                                        campo.texto
                                      ]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                        </template>
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <template
                            v-for="(subpregunta, subQIndex) in question
                              .pregunta_condicion[key].subpregunta"
                          >
                            <div
                              v-if="subpregunta.tipo === 'SELECCION'"
                              :key="'subCondQ' + subQIndex"
                              class="w-full px-3 mb-6 md:mb-0"
                            >
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subCondQ' + subQIndex"
                                >{{ subpregunta.id_pregunta }}.-
                                {{ subpregunta.texto }}</label
                              >
                              <p
                                v-if="subpregunta.nota_para_registrante"
                                class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                              >
                                {{ subpregunta.nota_para_registrante }}
                              </p>
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].subpregunta[subQIndex].respuesta
                                  "
                                  :name="'subCondQ' + subQIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subCondOptIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subCondOpt' + subCondOptIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                </select>
                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                    </div>

                    <div v-if="question.tipo === 'SELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, sOIndex) in question.opciones"
                            >
                              <option :key="'sO' + sOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                            <option v-if="question.otro" value="Otro">
                              Otro
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          v-if="
                            answers[index].respuesta.selected_answer === 'Otro'
                          "
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                      >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>

                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>

                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                        </div>
                      </template>
                    </div>

                    <div v-if="question.tipo === 'CAMPOS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <template
                          v-for="(campo, fieldIndex) in question.campos"
                        >
                          <template v-if="campo.tipo === 'texto'">
                            <div :key="'f' + fieldIndex">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'questionField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'questionField' + fieldIndex"
                                type="text"
                                :name="'questionField' + fieldIndex"
                                v-model="answers[index].respuesta[campo.texto]"
                              />
                            </div>
                          </template>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
<!--                         <div class="w-full px-3 mb-3">
                          <label class="w-full flex items-center text-gray-900">
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="answers[index].sensible"
                            />
                            <span class="text-sm">
                              Contiene información sensible
                            </span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flex w-full sticky bottom-0 justify-end py-5 bg-white"
              >
                <button
                  v-if="showFormView || showMultimediaView"
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="backView()"
                >
                  Atrás
                </button>
                <button
                  v-if="showCategoriesView"
                  class="ml-2 bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showMultimediaForm()"
                >
                  Subir foto o video
                </button>
                <button
                  v-if="showMultimediaView"
                  class="ml-2 bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="showLevantamientoForm()"
                >
                  Llenar ficha
                </button>
                <button
                  v-if="showFormView"
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento()"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full" v-if="answers.length === 0">
        <span class="text-sm tracking-wide text-purple-500"
          >Es necesario llenar la ficha del levantamiento</span
        >
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-500"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingMediaError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ mediaErrorMsg }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-500"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingMediaError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <levantamiento-project-modal
      :showing="showingProjectModal"
      :projectId="projectSelected"
      @close="showingProjectModal = false"
    ></levantamiento-project-modal>

    <project-media-levantamiento
      :showing="showingMediaProject"
      :especificacion="especificacion"
      @close="showingMediaProject = false"
    ></project-media-levantamiento>
  </div>
</template>
<script>
import config from "../../vue.config.js";
import AlertDialog from "./AlertDialog";
import moment from "moment";
import LevantamientoProjectModal from "./LevantamientoProjectModal";
import EventBus from "../event-bus";
import ProjectMediaLevantamiento from "./ProjectMediaLevantamiento";

export default {
  data() {
    return {
      fileMimeType: null,
      categorySelected: null,
      categories: [],
      subcategorySelected: null,
      subcategories: [],
      nameLevantamiento: null,
      showCategoriesView: true,
      showMultimediaView: false,
      showFormView: false,
      questions: [],
      answers: [],
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      audioSelected: false,
      errors: {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
        selectColab: false,
        selectProject: false,
        isMaterial: false,
        emptyFile: false,
        estado: false,
        municipio: false
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      projects: [],
      projectSelected: null,
      estados: [],
      //estado: "",
      selectedEstado: null,
      selectedMunicipio: null,
      municipios: [],
      //municipio:"",
      comunidad:"",
      fromProject: "",
      //isMaterial: null,
      isMaterial: 1, //ficha general por default
      imagesPreviews: [
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
      ],
      showingMediaError: false,
      mediaErrorMsg: "",
      showingProjectModal: false,
      showingMediaProject: false,
      especificacion: null,
      sensitiveLocation: false,
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    latitud: {
      required: true,
      type: Number,
    },
    longitud: {
      required: true,
      type: Number,
    },
    geometries: {
      required: true,
      type: Array,
    },    
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
    selectedEstado:function(){
      console.log("selectedEstado")
      console.log(this.selectedEstado)
      if(this.selectedEstado != null){
        this.fetchMunicipios();
      }
      
/*       if(this.selectedCategory != ""){
        this.fetchSubCategories(this.selectedCategory.id,this.selectedType.id);
      } */
    },  
  },
  mounted() {
    this.fetchEstados();
    this.fetchProjects();
    this.isMaterial= 1;
  },
  components: {
    AlertDialog,
    LevantamientoProjectModal,
    ProjectMediaLevantamiento,
  },
  methods: {
    reset: function () {
      this.fileMimeType = null;
      this.categorySelected = null;
      this.subcategorySelected = null;
      this.subcategories = [];
      this.nameLevantamiento = null;
      this.showCategoriesView = true;
      this.showMultimediaView = false;
      this.showFormView = false;
      this.questions = [];
      this.answers = [];
      this.imageSelected = false;
      this.videoSelected = false;
      this.audioSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
        selectProject: false,
        selectColab: false,
        isMaterial: false,
        emptyFile: false,
        estado: false,
        municipio: false
      };
      this.showingSuccess = false;
      this.showingError = false;
      this.projectSelected = null;
      this.fromProject = "";
      //this.isMaterial = null;
      this.comunidad = "";

      this.selectedEstado= null,
      //isMaterial: null,
      this.selectedMunicipio = null,

      this.isMaterial= 1; //ficha general por default
      this.imagesPreviews = [
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
        { type: "", mediaUrl: null, mimeType: "" },
      ];
      this.showingMediaError = false;
      this.mediaErrorMsg = "";
      this.showingProjectModal = false;
      this.showingMediaProject = false;
      this.especificacion = null;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    fetchEstados() {
      console.log("fetchEstados")
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/location/getEntidades",
          {
            activos: true,
          },
          this.config
        )
        .then((response) => {
          console.log(response)
          this.estados = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchMunicipios() {
      console.log("fetchMunicipios")
      console.log(this.selectedEstado)
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/location/getMunicipios",
          {
            entidad_cvegeo: this.selectedEstado.entidad_cvegeo,
          },
          this.config
        )
        .then((response) => {
          console.log(response)
          this.municipios = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.isMaterial,
            existente: true,
          },
          this.config
        )
        .then((response) => {
          this.questions = response.data.questions;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          console.log(error)
          if(error['response']){
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
          }

          this.$root.$emit("hideLoading");
        });
    },
    fetchProjectQuestions() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.projectSelected,
          },
          this.config
        )
        .then((response) => {
          this.questions = response.data.answers;

          this.formatQuestions();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          console.log(error)
          if(error['response']){
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    formatQuestions() {
      this.answers = [];
      this.questions.forEach((question) => {
        let answer;

        switch (question.tipo) {
          case "ABIERTA":
            answer = "";
            break;
          case "MULTISELECCION":
            answer = {
              opciones: {},
            };

            question.opciones.forEach((option) => {
              answer.opciones[option] = false;
            });

            if (question.otro) {
              answer["otro"] = "";
            }

/*             if (question["subpregunta"] && question["subpregunta"].length>0) {
              answer["subpregunta"] = {};
              answer["subpregunta"]["id_pregunta"] =
                question["subpregunta"][0].id_pregunta;
              answer["subpregunta"]["texto"] = question["subpregunta"][0].texto;
              answer["subpregunta"]["tipo"] = question["subpregunta"][0].tipo;
              answer["subpregunta"]["respuesta"] = {};
              if (question["subpregunta"][0].tipo == "CAMPOS") {
                answer["subpregunta"]["sensible"] = false;
                question["subpregunta"][0].campos.forEach((field) => {
                  answer["subpregunta"]["respuesta"][field.texto] = "";
                });
              }
            } */
            if (question["subpregunta"] && question["subpregunta"].length>0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach((question) => {
                  let subAnswer = {
                    respuesta: null,
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }

                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: "",
                    };
                  }

                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};

                    question.campos.forEach((campo) => {
                      subAnswer.respuesta[campo.texto] = "";
                    });
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }

            break;
          case "MULTISELECCION_CATEGORIAS":
            answer = {};
            if (question["otro"] == true) {
              answer["otro"] = "";
            }
            answer["categorias"] = {};
            question.categorias.forEach((categoria) => {
              answer["categorias"][categoria.categoria_nombre] = {};
              categoria.opciones.forEach((opcion) => {
                answer["categorias"][categoria.categoria_nombre][
                  opcion
                ] = false;
              });
            });
            break;
          case "SELECCION_CONDICIONAL":
            answer = {};
            answer["selected_answer"] = "";
            answer["conditional_answer"] = {};

            Object.entries(question.pregunta_condicion).forEach(
              ([key, value]) => {
                answer["conditional_answer"][key] = {};
                answer["conditional_answer"][key]["id"] = value["id"];
                answer["conditional_answer"][key]["tipo"] = value["tipo"];
                answer["conditional_answer"][key]["texto"] = value["texto"];

                if (value["tipo"] == "ABIERTA") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = "";
                }
                if (value["tipo"] == "MULTISELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = {};

                  answer["conditional_answer"][key]["respuesta"]["opciones"] =
                    {};
                  value["opciones"].forEach((opcion) => {
                    answer["conditional_answer"][key]["respuesta"]["opciones"][
                      opcion
                    ] = false;
                  });

                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }
                if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                  answer["conditional_answer"][key]["respuesta"] = {};
                  answer["conditional_answer"][key]["respuesta"]["categorias"] =
                    {};
                  value["categorias"].forEach((categoria) => {
                    answer["conditional_answer"][key]["respuesta"][
                      "categorias"
                    ][categoria.categoria_nombre] = {};
                    categoria.opciones.forEach((opcion) => {
                      answer["conditional_answer"][key]["respuesta"][
                        "categorias"
                      ][categoria.categoria_nombre][opcion] = false;
                    });
                  });
                  if (value["otro"] == true) {
                    answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                  }
                }

                if (value["tipo"] == "SELECCION") {
                  answer["conditional_answer"][key]["respuesta"] = "";
                }

                if (value["tipo"] === "CAMPOS") {
                  answer["conditional_answer"][key]["sensible"] = false;
                  answer["conditional_answer"][key]["respuesta"] = {};
                  question.pregunta_condicion[key].campos.forEach((field) => {
                    answer["conditional_answer"][key]["respuesta"][
                      field.texto
                    ] = "";
                  });
                }

                if (question.pregunta_condicion[key].subpregunta) {
                  let subAnswers = [];
                  question.pregunta_condicion[key].subpregunta.forEach(
                    (subpregunta) => {
                      let subAnswer = {
                        id_pregunta: subpregunta.id_pregunta,
                        texto: subpregunta.texto,
                        tipo: subpregunta.tipo,
                        respuesta: "",
                      };

                      if (subAnswer.tipo === "ABIERTA") {
                        subAnswer.sensible = false;
                      }

                      subAnswers.push(subAnswer);
                    }
                  );

                  answer["conditional_answer"][key].subpregunta = subAnswers;
                }

                answer["conditional_answer"][key]["error"] = false;
              }
            );
            break;
          case "SELECCION":
            answer = {};
            answer["selected_answer"] = "";
            if (question.otro) {
              answer["otro"] = "";
            }
            if (question["subpregunta"] && question["subpregunta"].length>0) {
              if (question["subpregunta"].length > 0) {
                answer["subpregunta"] = [];
                question["subpregunta"].forEach((question) => {
                  let subAnswer = {
                    respuesta: null,
                  };
                  subAnswer.id_pregunta = question.id_pregunta;
                  subAnswer.texto = question.texto;
                  subAnswer.tipo = question.tipo;
                  if (question.tipo === "ABIERTA") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = "";
                  }

                  if (question.tipo === "SELECCION") {
                    subAnswer.respuesta = {
                      selected_answer: "",
                    };
                  }

                  if (question.tipo === "CAMPOS") {
                    subAnswer.sensible = false;
                    subAnswer.respuesta = {};

                    question.campos.forEach((campo) => {
                      subAnswer.respuesta[campo.texto] = "";
                    });
                  }

                  subAnswer.error = false;

                  answer["subpregunta"].push(subAnswer);
                });
              }
            }
            break;
          case "CAMPOS":
            answer = {};
            question.campos.forEach((field) => {
              answer[field.texto] = "";
            });
            break;
          default:
            break;
        }

        let answerQuestion = {
          id_pregunta: question.id_pregunta,
          texto: question.texto,
          tipo: question.tipo,
          respuesta: answer,
          obligatoria: question.obligatoria,
          error: false,
        };

        if (
          answerQuestion.tipo === "ABIERTA" ||
          answerQuestion.tipo === "CAMPOS"
        ) {
          answerQuestion.sensible = false;
        }

        this.answers.push(answerQuestion);
      });
    },
    fetchProjects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/projects/getAllProjectsList",
          {
            activos: true,
          },
          this.config
        )
        .then((response) => {
          this.projects = response.data.proyectos;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    showMultimediaForm() {
      const form = document.getElementById("levantamientoForm");
      const formData = new FormData(form);
      const validForm = this.validateForm(formData);

      if (validForm) {
        let project = this.projects.find(
          (project) => project.id === this.projectSelected
        );

        if (project != null && project != undefined) {
          this.especificacion = project.especificaciones_multimedia;
        } else {
          this.especificacion =
            "Puede subir hasta cuatro fotografías (jpg) o un video (mp4) o un audio (mp3)";
        }

        this.showCategoriesView = false;
        this.showFormView = false;
        this.showMultimediaView = true;
      }
    },
    showLevantamientoForm() {
      const validForm = this.validateMultimedia();

      if (validForm) {
        this.showCategoriesView = false;
        this.showMultimediaView = false;
        this.showFormView = true;

        if (this.fromProject === "No") {
          this.fetchQuestions();
        } else {
          this.fetchProjectQuestions();
        }
      }
    },
    saveLevantamiento() {
      const validQuestions = this.validateAnswers();

      if (validQuestions) {
        this.$root.$emit("showLoading");
        let request = {};
        let date = new Date();
        //hace la correccion de time offset de la fecha
        let fecha = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        let fecha_registro = new Date().toLocaleString("es-MX", {
          timeZone: "America/Mexico_City",
        });

        let userAnswers = {};

        this.answers.forEach((answer) => {
          delete answer.error;
          if (answer.tipo === "SELECCION_CONDICIONAL") {
            let user_answer = {};
            for (let key in answer.respuesta.conditional_answer) {
              if (key === answer.respuesta.selected_answer) {
                delete answer.respuesta.conditional_answer[key].error;
                user_answer[key] = answer.respuesta.conditional_answer[key];
              }
            }

            answer.respuesta.conditional_answer = user_answer;
          }

          if (answer.tipo === "SELECCION") {
            if (answer.respuesta.selected_answer !== "Otro") {
              answer.respuesta.otro = "";
            }
            if (answer.respuesta.subpregunta) {
              if (answer.respuesta.subpregunta.length > 0) {
                answer.respuesta.subpregunta.forEach((subpregunta) => {
                  delete subpregunta.error;
                });
              }
            }
          }
        });

        this.questions.forEach((question, index) => {
          userAnswers[question.id_pregunta] = this.answers[index];
        });

        if (this.fromProject === "No") {
          this.projectSelected = null;
        } else {
          this.isMaterial = 3; //es ficha de proyecto
        }

        let dataToSendOptions = [];

        this.imagesPreviews.forEach((preview, index) => {
          if (preview.type !== "") {
            const newDate = new Date();
            const mediaFilename =
              localStorage.getItem("user_id") +
              "_" +
              newDate.getTime() +
              "_" +
              index +
              preview.extension;

            let options = {
              fileKey: "levantamientoFile",
              fileName: mediaFilename,
              mimeType: preview.mimeType,
            };

            dataToSendOptions.push(options);
          }
        });

        //******* */ convierte arreglo de geometrias en featureCollection
        console.log("GEOMETRIES:") 
        console.log(this.geometries)    
        
        if(this.geometries.length == 0){
          this.$root.$emit("hideLoading");
          alert("No ha dibujado ninguna geometría"); 
          return;
        } 
        else {
          console.log("")
          this.geometries.forEach(geometry => {

          if (!geometry.geometry) {
            geometry.geometry = {};
            geometry.properties = {};
            geometry.geometry.type = "";
            geometry.geometry.coordinates = geometry.coordinates
            geometry.geometry.type = geometry.type
            // geometry.properties.projectInfo = this.selectedProject;
            geometry.type = "Feature"
            delete geometry.coordinates;
            // console.log("al final, así queda geometry");
            // console.log(geometry);
          } else {
            // geometry.properties.projectInfo = this.selectedProject;
 /*            geometry.properties.projectInfo = {
              id: this.selectedProject.id,
              nombre: this.selectedProject.nombre
            };
            //geometry.properties.categoryInfo = this.selectedCategory;
            geometry.properties.categoryInfo = {
              id: this.selectedCategory.id,
              nombre: this.selectedCategory.nombre
            }
            //geometry.properties.typeInfo = this.selectedType;
            geometry.properties.typeInfo = {
              id: this.selectedType.id,
              nombre: this.selectedType.nombre            
            }

            //geometry.properties.subCategoryInfo = this.selectedSubCategory;
            geometry.properties.subCategoryInfo = {
              id: this.selectedSubCategory.id,
              nombre: this.selectedSubCategory.nombre              
            }

            geometry.properties.nombre = this.title
            geometry.properties.descripcion = this.description;
            geometry.properties.fecha = fecha_registro;          
            geometry.properties.metodo = "manual";
            geometry.properties.fuente = "web";
            geometry.properties.altitud = "N/A"; */
          }

          delete geometry.properties.geomID;
          if(geometry.properties.typeGeometry && geometry.properties.typeGeometry == "Buffer") {
            delete geometry.properties.layerBufferID;
          }
          });     
          
          // console.log(this.geometries);   

          let featureCollectionGeometries = {
            type: "FeatureCollection",
            features: this.geometries
          }             
          
                

    
        
        //******* /convierte arreglo de geometrias en featureCollection


        request = {
          id_cat_principal: this.isMaterial,
          id_cat_secundaria: 0,
          estado: this.selectedEstado.entidad_nombre,
          municipio: this.selectedMunicipio.municipio_nombre,
          localidad: this.comunidad,
          //id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          titulo: this.nameLevantamiento,
          registro: null,
          respuestas: userAnswers,
          multimedia: null,
          //fecha_levantamiento: new Date(),
          fecha_levantamiento: fecha_registro,
          //geometry: {},
          geojson: featureCollectionGeometries,
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
          file_type: this.fileMimeType,
          id_proyecto: this.projectSelected,
          DatatoSendOptions: dataToSendOptions,
          ubicacion_sensible: this.sensitiveLocation,
        };

        console.log(request)
        

        this.axios
          .post("apidev/levantamientos/newLevantamiento", request, this.config)
          .then((response) => {
            if (document.getElementById("levantamientoFile").value !== "") {
              let levantamientoId = response.data.levantamiento_id;
              let promises = [];

              dataToSendOptions.forEach((option, index) => {
                let formData = new FormData();
                formData.append("id", levantamientoId);
                const file =
                  document.getElementById("levantamientoFile").files[index];

                formData.append("levantamientoFile", file, option.fileName);

                let promise = this.axios.post(
                  "apidev/levantamientos/media",
                  formData,
                  this.config
                );

                promises.push(promise);
              });

              Promise.all(promises)
                .then((response) => {
                  this.showingSuccess = true;
                  this.$root.$emit("hideLoading");
                })
                .catch((error) => {
                  if (
                    error.response.status == 400 ||
                    error.response.status == 401
                  ) {
                    if (
                      error.response.data.name === "TokenExpiredError" ||
                      error.response.data.name === "InvalidTokenError" ||
                      error.response.data.name === "JsonWebTokenError"
                    ) {
                      this.$router.push({ path: "/login" });
                    }
                  }
                  this.$root.$emit("hideLoading");
                });
            } else {
              this.showingSuccess = true;
              this.$root.$emit("hideLoading");
            }
          })
          .catch((error) => {
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.$root.$emit("hideLoading");
          });


        } //else geometries
      }
    },
    backView() {
      if (this.showFormView) {
        this.showFormView = false;
        this.showMultimediaView = true;
      } else {
        if (this.showMultimediaView) {
          this.showMultimediaView = false;
          this.showCategoriesView = true;
        }
      }
    },
    validateForm(data) {
      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      console.log(data.get("estado"))
      console.log(this.selectedEstado)
      if (data.get("estado") === "" || data.get("estado") ==null) {
        this.errors.estado = true;
      } else {
        this.errors.estado = false;
      }      


      console.log(data.get("municipio"))
      console.log(this.selectedMunicipio)
      if (data.get("municipio") === "" || data.get("municipio") ==null) {
        this.errors.municipio = true;
      } else {
        this.errors.municipio = false;
      }   

      if (data.get("fromProject") === "" || data.get("fromProject") ==null) {
        this.errors.selectColab = true;
      } else {
        this.errors.selectColab = false;
      }


      if (data.get("fromProject") === "Si") {
        if (data.get("selectProject") === null) {
          this.errors.selectProject = true;
        } else {
          this.errors.selectProject = false;
        }
      }

/*       if (data.get("fromProject") === "No") {
        console.log(data.get("isMaterial"))
        if (data.get("isMaterial") === null) {
          this.errors.isMaterial = true;
        } else {
          this.errors.isMaterial = false;
        }
      } */

      if (
        this.errors.name ||
        this.errors.selectProject ||
        this.errors.selectColab ||
        this.errors.estado ||
        this.errors.municipio
        //this.errors.isMaterial
      ) {
        return false;
      }

      return true;
    },
    validateMultimedia() {
      if (document.getElementById("levantamientoFile").value === "") {
        this.errors.emptyFile = true;
      } else {
        this.errors.emptyFile = false;
      }

      return !this.errors.emptyFile;
    },
    changeLevantamientoFile(event) {
      const files = event.target.files;

      const filesArray = Array.from(files);
      console.log(filesArray)
      let videoArray = filesArray.filter((file) => file.type.includes("video"));
      console.log(videoArray)
      if (videoArray.length <= 1) {
        if (
          videoArray.length === 0 ||
          (videoArray.length === 1 && filesArray.length === 1)
        ) {
          if (filesArray.length <= 4) {
            //this.imageSelected = true;

            this.imagesPreviews = [
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" },
              { type: "", mediaUrl: null, mimeType: "" },
            ];
            this.inputFilePlaceholder = "";
            filesArray.forEach((file, index) => {
              const fileMimeType = this.checkMimeType(file);
              if (fileMimeType === "") {
                this.errors.file_extension = true;
              } else {
                switch(fileMimeType){
                  case ".mp4":
                    this.audioSelected = false;
                    this.imageSelected =false;
                    this.videoSelected =true;   

                    this.inputFilePlaceholder += `${file.name},`;
                    this.errors.file_extension = false;

                    this.imagesPreviews[index].type = "video";
                    this.imagesPreviews[index].mediaUrl =
                      URL.createObjectURL(file);
                    this.imagesPreviews[index].mimeType = file.type;
                    this.imagesPreviews[index].extension = fileMimeType;                    
                    break;
                  case ".jpg":
                  case ".jpeg":
                  case ".png":
                    this.audioSelected = false;
                    this.imageSelected =true;
                    this.videoSelected =false;    

                    this.inputFilePlaceholder += `${file.name},`;

                    let image = new Image();
                    image.src = URL.createObjectURL(file);
                    image.onload = () => {
                      this.errors.file_extension = false;

                      this.imagesPreviews[index].type = "image";
                      this.imagesPreviews[index].mediaUrl =
                        URL.createObjectURL(file);
                      this.imagesPreviews[index].mimeType = file.type;
                      this.imagesPreviews[index].extension = fileMimeType;
                    };                    
                    break;
                  case ".mp3":
                    this.audioSelected = true;
                    this.imageSelected =false;
                    this.videoSelected =false;
                    this.inputFilePlaceholder += `${file.name},`;
                    this.errors.file_extension = false;

                    this.imagesPreviews[index].type = "audio";
                    this.imagesPreviews[index].mediaUrl =
                      URL.createObjectURL(file);
                    this.imagesPreviews[index].mimeType = file.type;
                    this.imagesPreviews[index].extension = fileMimeType;                      
                    break;

                }
/*                 if (fileMimeType === ".mp4") {
                  this.inputFilePlaceholder += `${file.name},`;
                  this.errors.file_extension = false;

                  this.imagesPreviews[index].type = "video";
                  this.imagesPreviews[index].mediaUrl =
                    URL.createObjectURL(file);
                  this.imagesPreviews[index].mimeType = file.type;
                  this.imagesPreviews[index].extension = fileMimeType;
                } else {
                  this.inputFilePlaceholder += `${file.name},`;

                  let image = new Image();
                  image.src = URL.createObjectURL(file);
                  image.onload = () => {
                    this.errors.file_extension = false;

                    this.imagesPreviews[index].type = "image";
                    this.imagesPreviews[index].mediaUrl =
                      URL.createObjectURL(file);
                    this.imagesPreviews[index].mimeType = file.type;
                    this.imagesPreviews[index].extension = fileMimeType;
                  };
                } */
              }
            });
          } else {
            document.getElementById("levantamientoFile").value = "";
            this.mediaErrorMsg = "Seleccione un máximo de 4 fotos.";
            this.showingMediaError = true;
          }
        } else {
          document.getElementById("levantamientoFile").value = "";
          this.mediaErrorMsg = "Seleccione hasta 4 fotos o un video.";
          this.showingMediaError = true;
        }
      } else {
        document.getElementById("levantamientoFile").value = "";
        this.mediaErrorMsg = "Seleccione un máximo de un video.";
        this.showingMediaError = true;
      }
    },
    checkMimeType(file) {
      let mimeType = "";
      console.log("checkMimeType",file)
      switch (file.type) {
        case "image/jpeg":
          this.fileMimeType = "image/jpeg"
          mimeType = ".jpeg";
          break;
        case "image/png":
          this.fileMimeType = "image/jpeg"
          mimeType = ".png";
          break;
        case "image/jpg":
          this.fileMimeType = "image/jpeg"
          mimeType = ".jpg";
          break;
        case "video/mp4":
          this.fileMimeType = "video/mp4"
          mimeType = ".mp4";
          break;
        case "audio/mpeg":
          this.fileMimeType = "audio/mpeg"
          mimeType = ".mp3";          
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },
    validateAnswers() {
      let requiredAnswers = this.answers.filter((answer) => answer.obligatoria);

      let isValid = true;

      requiredAnswers.forEach((answer) => {
        switch (answer.tipo) {
          case "ABIERTA":
            if (answer.respuesta === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }
            break;
          case "SELECCION":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
            }

            if (answer.respuesta.subpregunta) {
              answer.respuesta.subpregunta.forEach((subpregunta) => {
                if (subpregunta.tipo === "ABIERTA") {
                  if (subpregunta.respuesta === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "SELECCION") {
                  if (subpregunta.respuesta.selected_answer === "") {
                    isValid = false;
                    subpregunta.error = true;
                  } else {
                    subpregunta.error = false;
                  }
                }

                if (subpregunta.tipo === "CAMPOS") {
                  let haveEmpty = false;
                  for (let key in subpregunta.respuesta) {
                    if (subpregunta.respuesta[key] === "") {
                      haveEmpty = true;
                      isValid = false;
                      subpregunta.error = true;
                    }
                  }

                  if (!haveEmpty) {
                    subpregunta.error = false;
                  }
                }
              });
            }

            break;
          case "SELECCION_CONDICIONAL":
            if (answer.respuesta.selected_answer === "") {
              isValid = false;
              answer.error = true;
            } else {
              answer.error = false;
              if (
                answer.respuesta.conditional_answer[
                  answer.respuesta.selected_answer
                ]
              ) {
                if (
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].respuesta === ""
                ) {
                  isValid = false;
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = true;
                } else {
                  answer.respuesta.conditional_answer[
                    answer.respuesta.selected_answer
                  ].error = false;
                }
              }
            }
            break;
          case "CAMPOS": {
            let haveEmpty = false;
            for (let key in answer.respuesta) {
              if (answer.respuesta[key] === "") {
                haveEmpty = true;
                isValid = false;
                answer.error = true;
              }
            }

            if (!haveEmpty) {
              answer.error = false;
            }
            break;
          }
          default:
            break;
        }
      });

      return isValid;
    },
    showProjectDetailModal() {
      this.showingProjectModal = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.projectSelected,
      });
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
